import { Expose, Type } from '@nts/std/serialization';
import { ExternalLayoutMetaData } from "./external-layout-meta-data";
import { GridMetaData } from "./grid-meta-data";
import { SimpleFieldMetaData } from "./simple-field-meta-data";
import { ExternalLayoutMetaDataInterface, ExtraLayoutMetaDataInterface, FieldMetaDataInterface, GridMetaDataInterface, SimpleFieldMetaDataInterface } from '@nts/std/interfaces';

export class ExtraLayoutMetaData implements ExtraLayoutMetaDataInterface {

    constructor() {
        this.simpleFields = [];
        this.externals = [];
        this.grids = [];
    }

    @Expose()
    @Type(() => SimpleFieldMetaData)
    simpleFields: SimpleFieldMetaDataInterface[];

    @Expose()
    @Type(() => ExternalLayoutMetaData)
    externals: ExternalLayoutMetaDataInterface[];

    @Expose()
    @Type(() => GridMetaData)
    grids: GridMetaDataInterface[];

    @Expose()
    get sortedFields(): FieldMetaDataInterface[] {
        return [...this.simpleFields, ...this.externals].sort((a, b) => a.position - b.position);
    }
}
